import { AttachedDocumentsTabFields } from '../../License/types/fieldEnums';
import { type IComparisonField } from '../types';

import { formatDate } from '../../../helpers/dateHelpers';

const attachedDocumentFields: IComparisonField[][] = [
  [
    {
      label: 'Code',
      fieldKey: AttachedDocumentsTabFields.code,
      tagKey: AttachedDocumentsTabFields.name,
    },
    {
      label: 'Reference Number',
      fieldKey: AttachedDocumentsTabFields.referenceNumber,
    },
    {
      label: 'Date',
      fieldKey: AttachedDocumentsTabFields.attachmentDate,
      render: formatDate,
    },
  ],
];

export default attachedDocumentFields;
